import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { syncStatusFilterConfig } from 'modules/integrations/lib/DataCollection/filters'

export const useSyncStatusFilterConfig = () => {
  const { syncEnabled, capabilityMode } = usePrivateIntegrationsSyncContext()
  if (!syncEnabled) return null

  return syncStatusFilterConfig(capabilityMode)
}
